import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Always attach Authorization header from localStorage as fallback for cross-origin cookies
http.interceptors.request.use((config) => {
  const token = localStorage.getItem("paiddewz_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(fileId) {
  const token = localStorage.getItem("paiddewz_token") || "";
  return `${API}/files/${fileId}?auth=${encodeURIComponent(token)}`;
}

export const STATUS_LABELS = {
  lead: "Lead",
  consult: "Consult",
  deposit_pending: "Deposit Pending",
  deposit_paid: "Deposit Paid",
  booked: "Booked",
  completed: "Completed",
};

export const STATUS_COLORS = {
  lead: "text-[#A3A8A4]",
  consult: "text-[#D2A853]",
  deposit_pending: "text-[#E2BC6A]",
  deposit_paid: "text-[#4CAF50]",
  booked: "text-[#4CAF50]",
  completed: "text-[#A3A8A4]",
};
